export const environment = {
    production: true,
    apiUrl: '/back',
    azureClientId: '47db7b0d-7856-4485-a3d2-954260f40e0c',
    azureTenantId: '8ff9753d-fb8c-46f2-a39f-a392a6df0586',
};
